<template>
  <v-card v-if="model.cve_empleado" class="elevation-2" color="grey lighten-3">
    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <h2 class="font-weight-bold title pa-2 text-center">Asistencias</h2>
          <v-toolbar class="elevation-2">
            <v-row dense class="mt-4">
              <v-col cols="12" sm="6" md="4" v-if="showDatePiker">
                <DatePicker :itemAction="datePiker" :on-success="actionFieldData"/>
              </v-col>
            </v-row>
          </v-toolbar>
          <DataTableMain :datatable="table" :on-success='successTableAction' :itemsAction='tableAction' />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import DatePicker from '@/components/fields/DatePicker'
import { Permission } from '@/mixins/permissionMain'
import { setTimeout } from 'timers'
export default {
  props: ['model', 'onSuccess'],
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newAdscripcionData', code: 'adscripcion.execute-create' },
          {
            title: 'Reportes',
            icon: 'mdi-cloud-download',
            color: 'light-blue lighten-1',
            code: 'asis.reportes',
            options: [
              { title: 'Reporte Analitico', icon: 'mdi-clipboard-text', color: 'blue darken-3', action: 'ExportAnalit' },
              { title: 'Reporte General', icon: 'mdi-clipboard-text', color: 'yellow darken-3', action: 'ExportGral' }
            ]
          }
        ],
        titles: [
          { text: 'Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Procesado', value: 'procesado', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Registro', value: 'Created', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateAdscripcionData', code: 'nomina-adscripciones.update' }
        ]
      },
      footer: {
        paging: true
      }
    },
    datePiker: {
      field: 'textDatePicker',
      name: 'Fecha',
      nameid: 'fecha',
      rules: [],
      default: true,
      cols: 6
    },
    showDatePiker: true,
    params: {},
    itemInsumos: {}
  }),
  components: {
    DataTableMain,
    DatePicker
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['postServiceListActionSecound']),
    ...mapMutations([]),
    /* *==========*==========*==========*==========*==========* */
    successTableAction (item) {
      item.item = this.model
      this.onSuccess(item)
    },
    tableAction (item) {
      this.onSuccess(item)
    },
    /* *==========*==========*==========*==========*==========* */
    actionFieldData (obj) {
      this.params[obj.id] = (obj.data) ? obj.data : null
      this.table.header.loading = true
      // this.params = { adscripcion_id: this.model.id, cve_empleado: this.model.cve_empleado }
      this.getUrl('POST/asistencia/show')
    },
    getUrl (objet) {
      const router = this.get_urls[objet]
      this.postServiceListActionSecound({ url: router, data: this.params })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectsSecound'])
  },
  watch: {
    model (val) {
      this.params = { adscripcion_id: val.id, cve_empleado: val.cve_empleado }
      this.showDatePiker = false
      setTimeout(() => {
        this.showDatePiker = true
      }, 300)
    },
    get_objectsSecound (val) {
      if (val) {
        this.table.header.loading = false
        this.table.body.data = val
      }
    }
  }
}
</script>

<style>
.container-foto {
  position: relative
}
.foto {
  display: block;
  margin: 0 auto;
}
</style>
